import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { UPDATE_PAYMENT } from "../apollo/mutations";
import { useEffect } from "react";
// import closeModal from "../common/closeModal";

const useEditPayment = (rowData, setShow) => {
  const defaultValues = {
    paying_type: rowData?.paying_type,
    description: rowData?.description,
  };

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ defaultValues });

  const [submit] = useMutation(UPDATE_PAYMENT);

  useEffect(() => {
    reset(defaultValues);
  }, [rowData, reset]);

  const onEditPayment = async (data) => {
    try {
      let payload = {
        variables: {
          input: {
            id: rowData?.id,
            paying_type: data?.paying_type,
            description: data?.description,
          },
        },
      };

      await submit(payload);
      reset(defaultValues);
      setShow(false)
      // closeModal("editpayment");
    } catch (error) {
      console.log("Mutation error:", error.message);
    }
  };

  const onCancel = () => {
    reset(defaultValues);
    setShow(false)
    // closeModal("editpayment");
  };

  return {
    values: {
      control,
      errors,
    },
    functions: {
      onSubmit: handleSubmit(onEditPayment),
      onCancel,
    },
  };
};

export default useEditPayment;
